import API from '../../services/API'
import {
    PROTEGES_GETTER,
    PROTEGES_GETTER_PROTEGE_ALL_INFO,
    PROTEGES_MUTATION_ENTIRE_PROTEGES,
    PROTEGES_MUTATION_PROTEGE_ALL_INFO,
    PROTEGES_MUTATION_DELETE_PROTEGE,
    PROTEGES_MUTATION_PHOTOS,
    PROTEGES_ACTION_GET_PROTEGES,
    PROTEGES_ACTION_GET_PROTEGE_ALL_INFO,
    PROTEGES_ACTION_DELETE_PROTEGE
} from './proteges-types'
import OAlert from '../../utils/OAlert/OAlert'
import Vue from 'vue'
import i18n from '../../assets/i18n/lang'

export default {
    namespaced: true,

    state: {
        proteges: [],
        currentAllInfoProtege: {
            profile: {},
            burial: {},
            ceremony: {},
            documents: {},
            guestlist: [],
            pets: []
        }
    },

    getters: {
        [PROTEGES_GETTER]: state => state.proteges,
        [PROTEGES_GETTER_PROTEGE_ALL_INFO]: state => state.currentAllInfoProtege
    },

    mutations: {
        [PROTEGES_MUTATION_ENTIRE_PROTEGES] (state, payload) { state.proteges = payload },
        [PROTEGES_MUTATION_PROTEGE_ALL_INFO] (state, payload) { state.currentAllInfoProtege = payload },
        [PROTEGES_MUTATION_DELETE_PROTEGE] (state, payload) {
            for (let i = 0; i < state.proteges.length; i++) {
                if (state.proteges[i].id === payload) {
                    state.proteges.splice(i, 1)
                }
            }
        },
        [PROTEGES_MUTATION_PHOTOS] (state, payload) {
            for (let i = 0; i < state.proteges.length; i++) {
                if (state.proteges[i].profile.id === payload.protegeId) {
                    Vue.set(state.proteges[i].documents.photos, payload.photo.index, payload.photo)
                }
            }
        }
    },

    actions: {
        [PROTEGES_ACTION_GET_PROTEGES] ({ commit }) {
            return new Promise(
                function (resolve, reject) {
                    API.loadProteges()
                        .then((protegesData) => {
                            commit(PROTEGES_MUTATION_ENTIRE_PROTEGES, protegesData)
                            for (let j in protegesData) {
                                let photos = protegesData[j].documents.photos
                                for (let i in photos) {
                                    API.downloadProtegePhotoFromBackend(protegesData[j].profile.id, photos[i].id)
                                        .then((data) => {
                                            photos[i].index = i
                                            photos[i].blob = data
                                            photos[i].oURL = URL.createObjectURL(data)
                                            let payload = {
                                                protegeId: protegesData[j].profile.id,
                                                photo: photos[i]
                                            }
                                            commit(PROTEGES_MUTATION_PHOTOS, payload)
                                        })
                                        .catch((error) => console.log(error.message))
                                }
                            }
                            resolve()
                        })
                        .catch((error) => {
                            console.log('' + error.message)
                            reject(error)
                        })
                })
        },
        [PROTEGES_ACTION_GET_PROTEGE_ALL_INFO] ({commit, state}, payload) {
            return new Promise(
                function (resolve, reject) {
                    console.log('all info')
                    API.loadProtege(payload)
                        .then((protegeData) => {
                            commit(PROTEGES_MUTATION_PROTEGE_ALL_INFO, protegeData)
                            resolve()
                        })
                        .catch((error) => {
                            console.log('' + error.message)
                            reject(error)
                        })
                })
        },
        [PROTEGES_ACTION_DELETE_PROTEGE] ({commit, state}, payload) {
            API.deleteProtege(payload)
                .then(() => {
                    OAlert.showSuccess('', i18n.t('feedback.protegeSucDelete'))
                    commit(PROTEGES_MUTATION_DELETE_PROTEGE, payload)
                })
                .catch((error) => console.log(error.message))
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/proteges.js